
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/[id]",
      function () {
        return require("private-next-pages/content/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/[id]"])
      });
    }
  